export default __webpack_public_path__ + "static/media/chevron-right.6e31335f.svg";